import { extractIdFromSlug } from './slug-id.mjs';
import { analyticsLanding } from './analytics-acquisition.mjs';
const KEY = 'musicmint:registration-attribution:v1';
const validID = value => typeof value === 'string' && /^[A-Za-z0-9_.:-]{1,128}$/.test(value) ? value : '';
// First-party acquisition persists independently; third-party IDs require consent.
export function createRegistrationAttribution({ storage, location, referrer, document, anonymousId, now = Date.now }) {
  let first, ids = {};
  function read() {
    try {
      const value = JSON.parse(storage().getItem(KEY) || 'null');
      if (value && value.created_at <= now() && now() - value.created_at < 7 * 86400000) return value;
    } catch { /* Optional storage. */ }
    return null;
  }
  return {
    capture(analyticsGranted = true) {
      if (first && (first.created_at > now() || now() - first.created_at >= 7 * 86400000)) first = undefined;
      first ||= read();
      if (!first) {
        const landing = analyticsLanding(location.href, referrer, location.origin), url = new URL(landing.page_location);
        const path = url.pathname;
        let token = '';
        try { token = extractIdFromSlug(decodeURIComponent(new URL(location.href).pathname.replace(/\/$/, '').split('/').pop())); } catch { /* Malformed escape. */ }
        const entry = path.startsWith('/share/') ? 'share' : path === '/create' ? 'create' : path === '/pricing' ? 'pricing' : path === '/extension' ? 'download' : 'other';
        first = { ...Object.fromEntries(url.searchParams), referrer_origin: landing.page_referrer, landing_path: path,
          entry, intent_surface: entry === 'share' ? 'listen' : entry === 'create' ? 'music_create' : entry === 'download' ? 'download_extension' : 'unknown', platform: 'web', ...(entry === 'share' && /^[A-Za-z0-9_-]{1,512}$/.test(token) ? { share_token: token } : {}), created_at: now() };
        try { storage().setItem(KEY, JSON.stringify(first)); } catch { /* Memory fallback. */ }
      }
      const aid = analyticsGranted ? validID(anonymousId()) : '';
      if (aid && analyticsGranted) {
        ids.anonymous_id = aid;
        document.cookie = `mm_aid=${aid}; Path=/; Secure; SameSite=Lax; Max-Age=604800`;
      }
    },
    setGA(value) { if (validID(value)) ids.ga_client_id = value; },
    params(analyticsGranted = true) {
      if (!first || first.created_at > now() || now() - first.created_at >= 7 * 86400000) return {};
      const result = { ...first, ...(analyticsGranted ? ids : {}) };
      delete result.created_at;
      for (const [cookie, field] of (analyticsGranted ? [['_clck','clarity_user_id'],['_clsk','clarity_session_id']] : [])) {
        const value = String(document.cookie || '').split(';').map(v => v.trim()).find(v => v.startsWith(cookie + '='))?.slice(cookie.length + 1).split(/[|%]/)[0];
        if (analyticsGranted && validID(value)) result[field] = value;
      }
      return result;
    },
    clearIDs() {
      ids = {};
      document.cookie = 'mm_aid=; Path=/; Secure; SameSite=Lax; Max-Age=0';
    },
    clear() {
      first = undefined; ids = {};
      try { storage().removeItem(KEY); } catch { /* Optional storage. */ }
      document.cookie = 'mm_aid=; Path=/; Secure; SameSite=Lax; Max-Age=0';
    },
  };
}
